import styled from 'styled-components';
import { LoadingButtonMixin } from '../../mixins/components/LoadingButtonMixin';
import { LoadingMask } from '../LoadingMask/LoadingMask';
export var StyledLoadingButton = /*#__PURE__*/styled(LoadingMask).withConfig({
  displayName: "StyledLoadingButton",
  componentId: "c11n-8-111-1__sc-2wv8o1-0"
})(["", ""], LoadingButtonMixin);